import { useGlobalData } from 'contexts';
import * as React from 'react';
import { Modal, ModalBody, ModalHeader } from '@teko/ds-mobile';
import { t } from 'i18n';

export interface ModalErrorTerminalProps {
  onOK?: () => void;
  onCancel?: () => void;
  showErrorTerminal: boolean;
  setShowErrorTerminal: (showErrorTerminal: boolean) => void;
}

export const ModalErrorTerminal = ({
  onOK,
  showErrorTerminal,
  setShowErrorTerminal,
  onCancel,
}: ModalErrorTerminalProps) => {
  const { supportedPhone } = useGlobalData();

  return (
    <Modal
      visible={showErrorTerminal}
      size="s"
      okText={t('Thử lại')}
      onOk={() => {
        onOK?.();
        setShowErrorTerminal(false);
      }}
      showCloseIcon={false}
      alignFooter="center"
      cancelText={t('Đóng')}
      onCancel={onCancel}
    >
      <ModalHeader padding="s0">{t('Thông báo')}</ModalHeader>
      <ModalBody paddingLeft="s0" paddingRight="s0">
        {t(
          'Không lấy được thông tin điểm bán để hiển thị. Vui lòng thử lại hoặc liên hệ {{supportedPhone}} để được hỗ trợ',
          { supportedPhone },
        )}
      </ModalBody>
    </Modal>
  );
};
